// The booking widget runs the app inside an iframe on "#/embedded/..." routes — both for
// third-party embeds and for the hosted "/#/book/..." page (which only renders that iframe).
// Requests made from that context must never inherit a logged-in session from shared
// localStorage — only the booking's own guest_token is allowed.
export const isEmbeddedContext = () => window.location.hash.startsWith("#/embedded/")
